import { ElementType, memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { formatCurrency } from './formatCurrency'
import { FormatCurrencyParams } from './types'
import { findCustomCurrency } from './customCurrencies'
import { isEmptyValue } from './utils'

export const LONG_DASH = '—'

export interface Props extends FormatCurrencyParams {
  tagName?: ElementType
  /**
   * @deprecated use wrapper to change styles instead.
   */
  className?: string
  /**
   * @deprecated use wrapper to change styles instead.
   */
  valueClassName?: string
  dataPointer?: string
  extendedNumber?: boolean
}

function FormattedCurrency({
  tagName = 'span',
  value,
  currency = '',
  isFiat,
  className,
  full,
  isSignAlwaysDisplay,
  cutSmallNumber,
  valueClassName,
  dataPointer,
  isCompact,
  maxPrecision,
  hideCurrency,
  extendedNumber,
}: Props) {
  const intl = useIntl()

  const content = useMemo(() => {
    if (isEmptyValue(value)) {
      return LONG_DASH
    }

    const handleCurrencyManually = !!valueClassName
    const stringValue = formatCurrency(intl.locale, {
      value,
      full,
      currency,
      hideCurrency: hideCurrency || handleCurrencyManually,
      isSignAlwaysDisplay,
      cutSmallNumber,
      isCompact,
      maxPrecision,
      isFiat,
      extendedNumber,
    })

    if (handleCurrencyManually && !hideCurrency) {
      const customCurrency = findCustomCurrency(currency)
      const currencySign = customCurrency?.sign ?? currency

      return (
        <>
          <span className={valueClassName}>{stringValue}</span>
          &nbsp;{currencySign}
        </>
      )
    }

    return stringValue
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    value,
    valueClassName,
    isFiat,
    intl.locale,
    full,
    currency,
    hideCurrency,
    isSignAlwaysDisplay,
    cutSmallNumber,
    isCompact,
    maxPrecision,
  ])

  const Component: React.ElementType | undefined = tagName
  return (
    <Component data-pointer={dataPointer} className={className}>
      {content}
    </Component>
  )
}

export default memo(FormattedCurrency)
